<template>
  <Layout class="p-2 p-sm-4">
    <div class="pageHeader">
      <div class="pageTitle">Panier</div>

 

      <div class="content">

          <div v-if="isShowSpinner" class="row">
              <div class="col-12 text-center">
                  <b-spinner variant="dark" ></b-spinner>
              </div>
          </div>

          <div v-if="!isShowSpinner && !cart" class="row mt-2 pt-4" style="min-height:350px;">
            <div class="col-12 text-center">
                <span class="text-warning font-weight-bold font-size-16">Vous n'avez aucun article dans votre panier</span>

                <p class="text-dark font-size-16 mt-2">
                        Explorer notre <a class="text-warning font-weight-bold" href="/catalogue/">catalogue d'articles</a> pour trouver des produits qui vous inspirent !
                    </p>

            </div>
          </div>

          <div v-if="deliveryFreethreshold && cartDeliveryFreePercent" >
            <div class="deliveryTitle">
              <span>Livraison gratuite à partir de {{ deliveryFreethreshold }}</span><span class="break-line"></span><span> d’achat !</span>
            </div>
            <div class="slider mt-4 mt-md-0">
              <div class="fill" 
                  :style="'background: linear-gradient(to right, #20c997 0%, #20c997 ' + cartDeliveryFreePercent + '%, #eaeaea ' + cartDeliveryFreePercent + '%, #eaeaea 100%)'"></div>
              <img class="sliderIcon" :style="'left: ' + cartDeliveryFreePercent + '%'" alt="" src="../../../assets/images/truck.svg" />
            </div>
          </div>
      </div>
    </div>
    
    <CartItems v-if="!isShowSpinner && cart" :cart="cart" ></CartItems>
    <CartSummary v-if="!isShowSpinner && cart" :cart="cart" :deliveryModes="deliveryModes"  ></CartSummary>
  </Layout>
</template>
<script>

import Layout from "../../layouts/main";
import CartItems from "../../../components/cartItems.vue";
import CartSummary from "../../../components/cartSummary.vue"
import CartApi from "@/services/cart-api";


export default ({
  name: "Cart",
  components: {
    Layout, CartItems, CartSummary
  },

  created() {
    this.$store.dispatch('fetchCart');
  },

  mounted() {
    this.getDeliveryModes();
  },

  data() {
        return {
            cart: null,
            deliveryModes: [],
        };
  },

  computed: {

        deliveryFreethreshold() {
          if (!this.cart || !this.cart.deliveryMode) {
            return null;
          }
          return this.cart.deliveryMode.deliveryFreeThresholdStr;
        },

        deliveryName() {
          if (!this.cart || !this.cart.deliveryMode) {
            return null;
          }
          return this.cart.deliveryMode.name;
        },

        cartDeliveryFreePercent() {
          if (!this.cart || !this.cart.lines) {
            return null;
          }
          return this.cart.lines.cartDeliveryFreePercent;
        },

        isShowSpinner() {
          return this.$store.state.isLoadingCart;
        }
  },

  watch: {
        '$store.state.cart': {
            handler(newCart) {
                this.cart = newCart;
            },
            deep: true,
        },
  },

  methods: {

    getDeliveryModes() {
      CartApi.getDeliveryModes().then(
        (deliveryModes)=> {
          this.deliveryModes = deliveryModes;
        }
      ).finally(() => {
        
      });
    }

  }
})
</script>
        
        
        
<style scoped>
.pageTitle {
  position: relative;
  font-size: 54px;
  letter-spacing: -1px;
  line-height: 58px;
  font-weight: 500;
  font-family: 'Space Grotesk';
  color: #121212;
}

.pageHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

/* Web view */
@media only screen and (min-width: 601px) {
  .pageHeader {
    padding-top: 4%;
  }
}

/* Mobile view */
@media only screen and (max-width: 600px) {
  .pageHeader {
    padding-top: 15%;
  }
}

@media only screen and (max-width: 600px) {
  .deliveryTitle {
    position: relative;
    top: 0px;
    left: 0px;
    display: inline-block;
    width: 100%;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    color: #121212;
    font-family: Inter;
  }
}

@media only screen and (min-width: 600px) {
  .deliveryTitle {
    position: relative;
    top: 0px;
    left: 0px;
    display: inline-block;
    width: 100%;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    color: #121212;
    font-family: Inter;
  }
}


.break-line {
  display: none;
}

@media only screen and (max-width: 600px) {
  .break-line {
    display: block;
    width: 100%;

  }
}


.elementscartcartGoal {
  width: 100%;
  position: relative;

}

.slider {
  width: 100%;
  height: 45px;

}

.fill {
  position: relative;
  top: 70%;
  left: 0;
  width: 100%;
  height: 7px;

  transform: translateY(-50%);
  border-radius: 45px;
}

.sliderIcon {
  position: relative;
  top: 70%;
  transform: translate(-60%, -60%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  border: 10px solid white;
}

/* Mobile view */
</style>